/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import { Login as loginApi } from './login';
import {
    START_LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    SETPRODUCTLIST,
    SETDOIURL
} from './actionTypes'

export function startLogin() {
    return {
        type: START_LOGIN
    }
}

export function loginSuccess(sid,userName) {
    return {
        type: LOGIN_SUCCESS,
        sid: sid,
        userName: userName
    }
}

export function loginFailure(error) {
    return {
        type: LOGIN_FAILURE,
        errorMessage: error.message
    }
}

export function setProductList(productlist) {
    return {
        type: SETPRODUCTLIST,
        productList: productlist
    }
}

export function setDoiUrl(url) {
    return {
        type: SETDOIURL,
        doiurl: url
    }
}

export function login(userName,password) {
    return dispatch => {
        dispatch(startLogin())
        return loginApi.get({
                userName: userName,
                password: password
            })
            .then(response => response.text())
            .then(sid => dispatch(loginSuccess(sid,userName)))
            .catch(function (error) {
                dispatch(loginFailure(error))
            })
    }
}